import { Navigate } from "react-router-dom";
import useLipaBidhaaStore from "../../stores/lipaBidhaaStore";

export default function LipaBidhaaFlowGuard({ children }) {
  const isFlowActive = useLipaBidhaaStore((state) => state.isFlowActive);

  if (!isFlowActive) {
    return <Navigate to="/lipa-bidhaa" replace />;
  }

  return children;
}
